module.exports = __webpack_public_path__ + "img/129.a088b9f6.jpg";